import {
  Avatar,
  Box,
  Collapse,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import * as React from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import GreenSwitch from "../ConfigPayroll/GreenSwitch";
import { MenuCourse } from "./MenuCourse";
import { v4 as uuidv4 } from "uuid";
import { Rating } from "@material-ui/lab";
import LogoBitsDefault from "../../assets/png/LogoBitsDefault.png";
import "../FormacionDesarrollo/css/TableCourse.css";
import CheckPermission from "../../helpers/Administradores/Permissions";
import { UPDATE_CURSO_SWITCH, GET_ALL_COURSES, GET_CURSOS_IN_PLANINGS } from "../../Querys/querys";
import { useMutation, useQuery } from "@apollo/client";
import { ErrorAlert } from "../../alerts/errorAlert";
function Row(props: { row: any }) {
  const [valueSecondTable, setValueSecondTable] = React.useState<any[]>([]);
  const { row } = props;
  const [updateCourseSwitch] = useMutation(UPDATE_CURSO_SWITCH, {
    refetchQueries: [{ query: GET_ALL_COURSES }],
  })
  const { data: getConteoCursos } = useQuery(GET_CURSOS_IN_PLANINGS, {
    variables: {
      id: parseInt(row.id)
    }
  })
  const conteo = getConteoCursos?.GET_CURSOS_IN_PLANINGS[0].conteo

  const updateCourseStatus = async (id: any) => {
    if (conteo > 0 && row.status === 'Activo') {
      ErrorAlert({ text: 'No es posible inactivar un curso que se encuentra en un plan de capacitacón' })
    } else {
      await updateCourseSwitch({
        variables:{
          id: id
        }
      })
    }
  };

  React.useEffect(() => {
    if (row.sedes.length > 0) {
      let arrayTable: any = [];
      let objtable = {};
      let arrayAreas: any = [];
      let area = row.areas;
      area.map((are: any) => {
        arrayAreas.push(are.area);
      });
      row?.sedes.map((sede: any) => {
        let count: Number = 0;
        let countComment: Number = 0;
        let avgSede: String = row?.average;
        //   row.sedeByCounts.map((countSede:any)=>{
        //        if(sede.sede === countSede.campus ){
        //          count= countSede.countBySede;
        //        }
        //     })

        //    row?.commentBySedeCount.map((countCommentSede:any)=>{
        //       if(sede.sede === countCommentSede.campus ){
        //         countComment= countCommentSede.countByComentario;
        //       }
        //    })
        //    row?.avgBySedes.map((avgCountSede:any)=>{
        //     if(sede.sede === avgCountSede.campus ){
        //       avgSede= avgCountSede.promedioSede;
        //     }
        //  })
        objtable = {
          ...objtable,
          id: row.id,
          // empresa:sede.name,
          sedes: sede.sede,
          evaluable: row.evaluable,
          areas: arrayAreas.toString(),
          //countColaboradores: countSede.countBySede ,
          countColaboradores: row?.countColaboradores,
          //  countRestricciones:row.countRestricciones,
          //  countComentarios: countComment,
          //promedio:row.promedio
          average: row?.average,
        };
        console.log(objtable);
        arrayTable.push(objtable);
      });
      setValueSecondTable(arrayTable);
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [open, setOpen] = React.useState(false);
  return (
    <React.Fragment>
      <TableRow>
        <TableCell className="cellSpanPrincipalPrestacion">
          <IconButton
            className="btnViewInfoPrestacion"
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell className="tableImgPrincipalPrestacion" align="left">
          <Avatar className="avatarImage">
            <img
              className="avatarImageCourse"
              alt={row.title}
              src={row.URL !== "" ? row.URL : LogoBitsDefault}
            />
          </Avatar>
        </TableCell>
        <TableCell className="tableTitlePrincipalPrestacion" align="left">
          {row.title}{" "}
        </TableCell>
        <TableCell className="TableheaderPrincipalPrestacion" align="left">
          | Instructor: {row.bussinesNameInstructor}{" "}
        </TableCell>
        <TableCell className="TableheaderPrincipalPrestacion" align="left">
          | Horas del curso: {row.hours}
        </TableCell>
        <TableCell
          className="TableheaderPrincipalPrestacion"
          align="left"
        ></TableCell>
        <TableCell className="tableActivaPrincipalPrestacion" align="right">
          {CheckPermission("FormacionDesarrollo.Cursos.Activar") && (
            <div className="switchPrestacion">
              <span className="actPrestacion">{row.status}</span>
              <GreenSwitch
                updatePayrollStatus={updateCourseStatus}
                id={row.id}
                status={row.status}
              />
            </div>
          )}
        </TableCell>
        <TableCell className="tableMenuPrincipalPrestacion" align="right">
          {" "}
          {(CheckPermission("FormacionDesarrollo.Cursos.Editar") ||
            CheckPermission("FormacionDesarrollo.Cursos.Eliminar")) && (
            <MenuCourse id={row.id} />
          )}{" "}
        </TableCell>
      </TableRow>
      <TableRow key={uuidv4()} className="headerTable2Prestaciones">
        <TableCell style={{ padding: 0 }} colSpan={10}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box>
              <Table>
                <TableHead className="pd_contenedorTitulos">
                  <TableRow key={uuidv4()}>
                    {/* <TableCell>Empresa</TableCell> */}
                    <TableCell>Sede</TableCell>
                    <TableCell>Área</TableCell>
                    <TableCell>Colaboradores</TableCell>
                    <TableCell>Calificación</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {valueSecondTable &&
                    valueSecondTable.map((info: any) => {
                      return (
                        <>
                          <TableRow key={uuidv4()}>
                            {/* <TableCell className='headerSecondTablePrestacion'>{info.empresa} </TableCell> */}
                            <TableCell className="tableSedePrestacion">
                              {info.sedes}{" "}
                            </TableCell>
                            <TableCell
                              className="tableAreaTablePrestacion"
                              align="left"
                            >
                              {" "}
                              {info.areas}
                            </TableCell>
                            <TableCell align="left">
                              {" "}
                              <span className="tableCountSecondTablePrestacion">
                                {info.countColaboradores}
                              </span>{" "}
                            </TableCell>

                            <TableCell align="left">
                              <Rating
                                name="half-rating-read"
                                defaultValue={info.average}
                                precision={0.5}
                                size="small"
                                readOnly
                              />
                            </TableCell>
                          </TableRow>
                        </>
                      );
                    })}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

const TableCourse = ({ courses }: any) => {
  const rows = courses;
  console.log(rows);
  return (
    <TableContainer component={Paper}>
      <Table className="tablePrestacion" aria-label="collapsible table">
        <TableBody>
          {rows.map((row: any) => (
            <Row key={row.id} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableCourse;
